import React from "react";
import get from "lodash/get";
import { object, number } from "prop-types";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/card-image";
import Headline from "../../atoms/headline";
import PlaceholderImage from "../../atoms/placeholder-image";

const CardImageLarge = ({ story = {}, headerType = 7, headlineLimit }) => {
  const storyObj = story.story ? story.story : story;
  const slug = storyObj["hero-image-s3-key"];
  const storyImageSlug = get(storyObj, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);
  return (
    <Link href={`/${storyObj.slug}`}>
      {storyImageSlug ? (
        <CardImage story={storyObj} aspectRatio={[16, 9]} eagerLoad={true} />
      ) : (
        <PlaceholderImage story={storyObj} />
      )}
      <Headline
        story={storyObj}
        text={storyObj.headline}
        headerLevel={2}
        headerType={headerType}
        headlineLimit={headlineLimit}
      />
    </Link>
  );
};

export default CardImageLarge;

CardImageLarge.propTypes = {
  story: object,
  headerLevel: number,
  headerType: number,
  headlineLimit: number
};
